import { HAObject } from "../HAObject";
import { Tag } from "../HTML/Tag";
import { Data } from "../Repository/Data";
import { ControllerRegistry } from "../Registry/ControllerRegistry";
import { toMap, getWebPageService } from "../../../HA";

export class Controller extends HAObject {
    private w4reload: any;

    public getTag(): any {
        return super.getTag();
    }

    protected click() {
        const data = toMap(this.get("click"));
        switch (data.get("func")) {
            case  "toggleApp" :
                getWebPageService().toggleApp(data);
                break;
            case  "showApp" :
                getWebPageService().showApp(data);
                break;
            case  "reloadApp" :
                getWebPageService().reloadApp(data);
                break;
            case  "showPreviousApp" :
                getWebPageService().showPreviousApp();
                break;
            case  "toggleQMenu" :
                getWebPageService().toggleQMenu();
                break;
            default :
                break;
        }
    }

    protected initControllers() {
        const tag: Tag = this.getTag();
        const controllersData = toMap(this.get("controllers"));
        controllersData.delete("pm");
        const controllers = new Map();
        controllersData.forEach((controllerData: any) => {
            controllerData = toMap(controllerData);
            const cname = controllerData.get("n");
            const registryName = this.getControllerRegistryName(cname);
            if (registryName && ControllerRegistry.has(registryName)) {
                const data = controllerData;
                data.set("services", this.getServiceManager());
                data.set("parentTag", tag);
                data.set("appId", this.get("_id") || this.get("id"));
                if (this.has("pfunc")) {
                    data.set("pfunc", this.get("pfunc"));
                }
                controllers.set(cname, ControllerRegistry.create(registryName, data));
            }
        });
    }

    // Dispatch par registre (ha/441j) — remplace l'ancien `getControllerClass`
    // qui retournait directement les classes SearchableController/MenuController
    // (import-valeur créant un cycle Controller ↔ sous-contrôleurs Page).
    protected getControllerRegistryName(name: string): string | null {
        switch (name) {
            case "rl": return "SearchableController";
            case "m":  return "MenuController";
            default:   return null;
        }
    }

    protected watch4Reload(func: () => void) {
        this.w4reload = (_event: Event) => {
            this.w4rListener(func);
        };
        document.addEventListener("scroll", this.w4reload);
    }

    protected w4rListener(func: () => void) {
        const element = document.scrollingElement;
        const a = element.scrollTop + element.clientHeight;
        if (a * 1.1 > element.scrollHeight) {
            func();
        }
    }

    protected removeWatch4Reload() {
        document.removeEventListener("scroll", this.w4reload);
    }

    protected getDataRepository(): Data {
        if (this.hasNot("dataRepository")) {
            this.addToData("dataRepository", new Data());
        }

        return this.get("dataRepository");
    }
}
